<template>

    <div>

        <Tabbed uriRoot="admin" :names="{ Users: { title: 'Users' }, Projects: { title: 'Projects' }, Coupons: { title: 'Coupons' }, Failures: { title: 'Failures' }, Credits: { title: '', tab: 'Analysis' }, DashboardUpdates: { title: 'Dashboard Updates', tab: 'Dashboard Updates' } }">
            <template #Users>
                <Users />
            </template>
            <template #Projects>
                <Projects />
            </template>
            <template #Coupons>
                <Coupons />
            </template>
            <template #Failures>
                <Failures />
            </template>
            <template #Credits>
                <Credits />
            </template>
            <template #DashboardUpdates>
                <DashboardUpdates />
            </template>
        </Tabbed>

    </div>

</template>

<script>
import Tabbed from './Tabbed.vue'
import Users from './Admin/Users.vue'
import Projects from './Admin/Projects.vue'
import Coupons from './Admin/Coupons.vue'
import Failures from './Admin/Failures.vue'
import Credits from './Admin/AnalysisCredits.vue'
import DashboardUpdates from './Admin/DashboardUpdates.vue'

export default {
    name: 'Admin',
    components: { Tabbed, Users, Projects, Coupons, Failures, Credits, DashboardUpdates },
    data() {
        return {
            
        }
    },
    methods: {
        
    }
}
</script>